export const ActionTypes = {
  INIT_APP: 'APP/INIT_APP', // TODO: add action creator
  SET_ADZONE: 'APP/SET_ADZONE',
  SBM_INIT: 'APP/SBM_INIT/REQUEST',
  SET_SBM_LOADED: 'APP/SET_SBM_LOADED',
  SET_AD_LAYOUT: 'APP/SET_AD_LAYOUT',
  SET_HARD_PAGE_LOAD: 'APP/SET_HARD_PAGE_LOAD',
  NAVIGATED: 'APP/NAVIGATED',
  FLOWED: 'APP/FLOWED',
  LOCATION_CHANGE: 'APP/LOCATION_CHANGE',
  INITIALIZED: 'APP/JWT_INITIALIZED',
  SET_UPDATE_MESSAGING_FLAG: 'APP/SET_UPDATE_MESSAGING_FLAG',
} as const
